import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { useLenis } from "@/hooks/useLenis";
import { ScrollManager } from "@/components/layout/ScrollManager";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { AdminLayout, RequireAdmin } from "@/components/admin/AdminLayout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Contacts from "@/pages/Contacts";
import Legal from "@/pages/Legal";
import Reorder from "@/pages/Reorder";
import ReviewOrder from "@/pages/ReviewOrder";
import { COOKIES, PRIVACY, TERMS } from "@/data/legal";

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <ScrollManager />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/collezione" element={<Shop />} />
              <Route path="/prodotto/:slug" element={<ProductPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/contatti" element={<Contacts />} />
              <Route path="/privacy" element={<Legal key="privacy" doc={PRIVACY} />} />
              <Route path="/cookie" element={<Legal key="cookie" doc={COOKIES} />} />
              <Route path="/termini" element={<Legal key="termini" doc={TERMS} />} />
              <Route path="/riordina" element={<Reorder />} />
              <Route path="/recensione/:token" element={<ReviewOrder />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="login" element={<AdminLogin />} />
              <Route index element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
